import styled from '@emotion/styled';
const Wrapper = styled.div `
  width: 100%;
  min-height: ${({ minHeight }) => minHeight}px;
  video, img {
    display: inline-block;
    width: 100%;
    vertical-align: bottom;
    min-height: ${({ minHeight }) => minHeight}px;
    object-fit: fill;
  }
`;
export default Wrapper;
